<template>
  <DashboardTemplate :navMenu="true">
    <h2 class="text-left">การแจ้งเตือนทั้งหมด</h2>
    <div v-loading="loading">
      <div v-if="notiListLimit.length > 0">
        <div v-for="item in notiListLimit" :key="item._id">

          <NotificationCard
            v-if="item.type == 1"
            :id="item._id"
            :courseId="item.courseId"
            :image="item.illustration.file"
            :message="item.name"
            :date="`${item.verbs} ${item.time}`"
            :readed="item.read"
            @readNotification="readNotification"
          />

          <NotificationRegisterCard 
            v-if="item.type == 2"
            :id="item._id"
            :courseName="item.name"
            :verbs="item.verbs"
            :date="item.createdAt"
            :readed="item.read"
            :userId="item.userId"
            :profileImg="item.profileImg"
            :userFrom="item.userFrom"
            :profileFrom="item.profileFrom"
            :nameTH="item.nameTH"
            :surnameTH="item.surnameTH"
            @readNotification="readNotification"
          />
        </div>
        <div class="pd-y-4">
          <a
            v-if="notiListLimit.length < notiList.length"
            @click="loadNoti"
            class="color-secondary text-font-16 text-underline"
            >ดูข้อมูลต่อ</a
          >
        </div>
      </div>
      <div v-else>
        <p class="color-gray pd-t-1">*** ไม่มีข้อความ ***</p>
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import NotificationCard from "@/components/notification/NotificationCard";
import NotificationRegisterCard from "@/components/notification/NotificationRegisterCard";

import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    NotificationRegisterCard,
    NotificationCard
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    notiListLimit() {
      return this.notiList.slice(0, this.limit);
    },
  },
  mounted() {
    this.fetchNotification();
  },
  data() {
    return {
      notiList: [],
      loading: true,
      limit: 5,
    };
  },
  methods: {
    fetchNotification() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`noti`)
        .then((res) => {
          if (res.data.success) {
            this.notiList = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          this.$store.commit("SIGNOUT");
          this.$router.push({ path: "/" }).catch(() => {
            window.location.reload();
          })
          console.log("fetchNotification error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    readNotification(id) {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`read/${id}`).then((res) => {});
    },
    loadNoti() {
      this.loading = true;
      this.limit = this.limit + 5;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
  },
};
</script>
